import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";
// import { Global } from '../utils/general';
import { Grid, Button, Typography, Box, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import headerRequest from '../../../utils/headers';
import { Global } from '../../../utils/general';
import { Toast } from '../../../utils/alerts';

const API_URL = Global.url;

const SignatureUpload = ({ user_id, setOpenModalLoader }) => {
  const [image, setImage] = useState(null); // archivo seleccionado nuevo
  const [previewUrl, setPreviewUrl] = useState(''); // preview actual (base64 o URL)
  const [error, setError] = useState('');
  const dropRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!user_id) return; // Evita la llamada si user_id es undefined

    const fetchSignature = async () => {
      try {
        const headers = await headerRequest();
        const response = await axios.get(`${API_URL}/user/${user_id}/firma-url`, {
          headers,
        });

        if (response.data?.url) {
          setPreviewUrl(`${response.data.url}`);
        }
      } catch (error) {
        console.error('Error al obtener la firma temporal:', error);
      }
    };

    fetchSignature();
  }, [user_id]);

  const validateAndSetImage = (file) => {
    setError('');
    if (!file) return false;

    if (file.type !== 'image/png') {
      setError('El archivo debe ser una imagen PNG.');
      return false;
    }

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      setError('El archivo debe pesar menos de 2MB.');
      return false;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);

    setImage(file);
    return true;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    validateAndSetImage(file);
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const dt = e.dataTransfer;
    if (dt.files && dt.files.length > 0) {
      validateAndSetImage(dt.files[0]);
      dt.clearData();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handlePaste = (e) => {
    const clipboardItems = e.clipboardData.items;
    for (let i = 0; i < clipboardItems.length; i++) {
      const item = clipboardItems[i];
      if (item.type === 'image/png') {
        const file = item.getAsFile();
        validateAndSetImage(file);
        e.preventDefault();
        break;
      }
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setPreviewUrl('');
    setError('');
    // Opcional: aquí podrías notificar al padre que la firma fue eliminada
  };

  const handleUpload = async () => {
    if (!image) {
      Toast.fire({
        icon: 'error',
        title: 'Por favor selecciona una imagen primero.'
      });
      return;
    }
    setOpenModalLoader(true);
    const formData = new FormData();
    formData.append('signature', image);

    try {
      const headers = await headerRequest(); // Asegúrate que esto devuelve correctamente el objeto de headers
      const response = await axios.post(
        // `http://localhost/server_assistance/public/api/user/${user_id}/signature`,
        `${API_URL}/user/${user_id}/signature`,
        formData,
        {
          headers: {
            ...headers,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('Respuesta de subida de firma:', response.data);
      

      // if (response.data && response.data.signature_url) {
      //   setPreviewUrl(response.data.signature_url);
      // }

      Toast.fire({
        icon: 'success',
        title: 'Firma subida correctamente'
      });

    } catch (err) {
      console.error(err);
      Toast.fire({
        icon: 'error',
        title: 'No se pudo subir la firma.'
      });
    } finally {
      setOpenModalLoader(false);
      setImage(null); // Limpiar la imagen después de subir
      if (fileInputRef.current) {
        fileInputRef.current.value = null; // Limpiar el input file
      }
    }
  };

  useEffect(() => {
    window.addEventListener('paste', handlePaste);
    return () => {
      window.removeEventListener('paste', handlePaste);
    };
  }, []);

  const handleAreaClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Box className="page-body-main">
      <Box className="page-body__table">
        <Box className="page-body-table" sx={{ paddingTop: '1rem' }}>
          <Grid container spacing={2} paddingX={2}>
            <Grid item xs={12}>
              <Typography variant="h5" className="page-body-table__title">
                Firma
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {/* Input oculto */}
              <input
                ref={fileInputRef}
                accept="image/png"
                type="file"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />

              {/* Área para drop, drag y click */}
              <Paper
                variant="outlined"
                sx={{
                  border: '2px dashed #ccc',
                  backgroundColor: '#fafafa',
                  padding: 2,
                  textAlign: 'center',
                  mb: 2,
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  position: 'relative',
                }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onClick={handleAreaClick}
                ref={dropRef}
              >
                <Typography>Arrastra y suelta tu firma PNG aquí</Typography>
                <Typography variant="caption">
                  También puedes pegar la imagen desde el portapapeles (Ctrl + V)
                </Typography>

                {previewUrl && (
                  <Box
                    sx={{
                      position: 'relative',
                      display: 'inline-block',
                      border: '1px solid #ccc',
                      backgroundColor: 'white',
                      maxWidth: '300px',
                      padding: '0.5rem',
                      marginTop: 2,
                      mx: 'auto',
                    }}
                  >
                    <img
                      src={previewUrl}
                      alt="Vista previa de firma"
                      style={{ display: 'block', maxWidth: '100%' }}
                    />
                    <IconButton
                      aria-label="Quitar imagen"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveImage();
                      }}
                      sx={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        '&:hover': {
                          backgroundColor: 'rgba(255,255,255,1)',
                        },
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Paper>

              <Box sx={{ textAlign: 'center' }}>
                <Button variant="contained" color="primary" onClick={handleUpload}>
                  Subir Firma
                </Button>
              </Box>

              {error && (
                <Typography color="error" sx={{ mt: 1 }}>
                  {error}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default SignatureUpload;
